var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mawProducts && !_vm.loadingProductsList)?_c('ProductsGrid',{attrs:{"title":_vm.$t('Discover Products'),"layout":"row","products":_vm.mawProducts,"grid-id":"discover-products"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }